import React, { Component } from 'react';
import config from '../../config';
import Helmet from 'react-helmet';

export default class Copyright extends Component {
  render() {
    return (
      <div className="container">
        <Helmet
          title="Twine Platform Terms of Use"
          link={[
            { rel: 'canonical', href: config.baseUrl + '/platform-terms' },
          ]}
        />

        <h1 className="lato-bold text-uppercase text-center aside-text mt mb">
          Twine Platform Terms of Use
        </h1>

        <div className="panel p++">
          <p className="lato-regular">
            <strong>PLEASE READ THESE TERMS CAREFULLY</strong>
          </p>
          <p className="lato-regular">
            This version is dated <strong>7 August 2026</strong>.
          </p>
          <p className="lato-regular">
            BY USING THE TWINE PLATFORM AND SUBSCRIBING TO OUR SERVICES YOU
            AGREE TO THESE TERMS. IF YOU DO NOT AGREE TO THESE TERMS DO NOT USE
            THE TWINE PLATFORM.
          </p>
          <p className="lato-regular">
            YOUR ATTENTION IS PARTICULARLY DRAWN TO THE PROVISIONS OF CLAUSE 13
            (LIMITATION OF LIABILITY).
          </p>

          <ol>
            <li>
              <h3 className="lato-bold mt mb pl">About us</h3>
              <p className="lato-regular">
                1.1 &nbsp;&nbsp;<strong>Who we are.</strong> We trade under the
                name <strong>"Twine"</strong> and we are Clowdy Limited a
                company registered in England and Wales. Our company
                registration number is 08195808 and our registered office is at
                3rd Floor, 86-90 Paul Street, London EC2A 4NE.
              </p>
              <p className="lato-regular">
                1.2 &nbsp;&nbsp;<strong>Contacting us.</strong> To contact us,
                please visit our <a href="/support">Support</a> page.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">What these terms do</h3>
              <p className="lato-regular">
                2.1 &nbsp;&nbsp;The Twine Platform is for use by business users
                (whether sole traders, partnerships or companies / corporations)
                only. The Twine Platform is provided subject to these terms and
                conditions (<strong>"Terms"</strong>). It is a platform where
                freelancers providers of creative content (
                <strong>"Sellers"</strong>) and potential buyers of creative
                content (<strong>"Buyer"</strong>) can meet, download or upload
                materials (<strong>"Content"</strong>) and engage for the
                provision of services by the Seller (an{' '}
                <strong>"Engagement"</strong>). You may also subscribe to
                services we offer (the <strong>"Subscription Services"</strong>)
                subject to these Terms.
              </p>
              <p className="lato-regular">
                2.2 &nbsp;&nbsp;Where we refer to "You", we are referring to you
                as either a Seller or a Buyer. These Terms are only in respect
                of your use of the Twine Platform and where you subscribe to our
                services,{' '}
                <strong>
                  <u>and are not in respect of any Engagement</u>
                </strong>
                . For any Engagement the{' '}
                <a href="/engagement-terms">
                  Twine Engagement Terms and Conditions
                </a>{' '}
                will apply for the Buyer and Seller.
              </p>
              <p className="lato-regular">
                2.3 &nbsp;&nbsp;Where we refer to "jobs" on our website, we are
                referring to Engagements between contracts and the use of the
                word "job" is not intend to imply any employment relationship.
              </p>
              <p className="lato-regular">
                2.4 &nbsp;&nbsp;Your use of the Twine Platform and the
                Subscription Services is also subject to the following terms:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Our Website{' '}
                    <a href="/terms">Terms and Conditions</a>;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Our <a href="/aup">Acceptable Use Policy</a>;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Our <a href="/privacy">Privacy Policy</a>; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Our <a href="/cookies">Cookie Policy</a>, which
                    sets out information about the cookies on our site.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                2.5 &nbsp;&nbsp;You must be 18 to accept these Terms, and to use
                the Twine Platform and receive any Subscription Services.
              </p>
              <p className="lato-regular">
                2.6 &nbsp;&nbsp;We may need to change these terms to reflect
                changes in law or best practice or to deal with additional
                features which we introduce. Next time you use the Twine
                Platform following any changes to these terms, you will be asked
                to agree to the amended terms before you can use the Twine
                Platform. If you do not accept the changes you will not be
                permitted to continue to use the Twine Platform and the
                Subscription Services.
              </p>
              <p className="lato-regular">
                2.7 &nbsp;&nbsp;Twine reserves the right to modify the Terms.
                You are responsible for providing your own access to the
                Service. Twine has no obligation to screen or monitor Content
                and does not guarantee that Content available on the Service
                complies with the Terms and Conditions or is suitable for all
                users.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">
                Use of the Twine Platform and our Subscription Services
              </h3>
              <p className="lato-regular">
                3.1 &nbsp;&nbsp;We license you to use the Twine Platform and any
                Subscription Services you subscribe for as permitted in these
                Terms.
              </p>
              <p className="lato-regular">
                3.2 &nbsp;&nbsp;Twine provides its users with a business to
                business technology platform. We expressly do not provide any
                services as a recruitment or temporary work agency (as defined
                by the Agency Workers Regulations 2010, the Employment Agencies
                Act 1973 and the Conduct of Employment Agencies and Employment
                Business Regulations 2003). Twine shall not moderate or
                intervene in the relationship between the Buyer and the Seller
                except where expressly provided for in these Terms and shall not
                conduct any checks on a Buyer's suitability for any Engagement.
                You agree that Twine is not a party to any contract between the
                Buyer and the Seller. Twine shall have no involvement in and
                shall not intervene in any dispute between the Buyer and the
                Seller.
              </p>
              <p className="lato-regular">
                3.3 &nbsp;&nbsp;
                <strong>
                  <u>Sellers:</u>
                </strong>{' '}
                Twine is not under any obligation to provide any Seller with an
                Engagement or supply any Buyer with a Seller for an Engagement.
                Sellers shall exclusively determine whether they have the skills
                and experience required for each Engagement. Sellers are not
                employed by Twine and Twine does not control what Engagements
                the Sellers accept or what terms they agree to. Sellers are
                solely responsible for determining, and have the sole right to
                determine, what Engagement(s) to accept and are not supervised,
                controlled or directed by Twine.
              </p>
              <p className="lato-regular">
                3.4 &nbsp;&nbsp;
                <strong>
                  <u>Buyers:</u>
                </strong>{' '}
                Buyers are permitted to post project briefs on Twine's website.
                Buyers are expressly{' '}
                <strong>
                  <u>not permitted</u>
                </strong>{' '}
                to post any advertisements which seek to recruit an individual
                to work as an{' '}
                <strong>
                  <u>employee</u>
                </strong>{' '}
                (incluing full-time, part-time, permanent or temporary) whether
                with the Buyer or any other employer on Twine's website and any
                such posts will be removed. By posting a project brief on our
                site, you confirm that you are seeking to engage a freelancer
                for genuine project-based work, and not for the purpose of
                recruiting on behalf of, or directing users toward, a competing
                platform or service. Buyers shall exclusively determine whether
                the Seller has the skills and experience to undertake an
                engagement and Twine makes no warranty as to the Sellers'
                suitability for an Engagement.
              </p>
              <p className="lato-regular">
                3.5 &nbsp;&nbsp;You agree to indemnify Twine for any losses,
                including fines and legal costs, howsoever caused which arise
                from your breach of 3.2, 3.3 and 3.4 of these Terms.
              </p>
              <p className="lato-regular">
                3.6 &nbsp;&nbsp;The Twine Platform and the Subscription Services
                are provided on an "as is" and "as available" basis. You
                therefore use the Twine Platform and the Subscription Services
                at your own risk. Twine expressly disclaims any and all
                warranties of any kind, whether express or implied, including,
                but not limited to the implied warranties of merchantability,
                fitness for a particular purpose, non-infringement, and any
                other warranty that might arise under any law. Without limiting
                the foregoing, Twine makes no representations or warranties:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;that the Twine Platform nor Subscription
                    Services will be uninterrupted or error-free;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;that the Twine Platform nor the Subscription
                    Services will be permitted in your jurisdiction;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;concerning any Content submitted by any user;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;concerning any third party's use of Content that
                    you upload;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;that your Content will be made available on the
                    Twine Platform or will be stored by Twine;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;that Twine will continue to support any
                    particular feature of the Twine Platform or any Service;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;that the Twine Platform nor Subscription
                    Services will meet your business or professional needs; or
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;concerning sites and resources outside of the
                    Subscription Service, even if linked to from the Service.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                3.7 &nbsp;&nbsp;
                <strong>
                  We are not responsible for other websites you link to
                </strong>{' '}
                the Twine Platform or the Subscription Services may contain
                links to other independent websites which are not provided by
                us. Such independent sites are not under our control, and we are
                not responsible for and have not checked and approved their
                content or their privacy policies (if any).
              </p>
              <p className="lato-regular">
                3.8 &nbsp;&nbsp;You will need to make your own independent
                judgement about whether to use any such independent sites,
                including whether to buy any products or services offered by
                them.
              </p>
              <p className="lato-regular">
                3.9 &nbsp;&nbsp;Twine may at any time, at its sole discretion
                and without liability to you, remove or amend any featured role,
                skill or category listed on a Seller's profile, limit the number
                of categories in which a Seller may offer services or apply for
                Engagements, or restrict the number of applications a Seller may
                have, where in Twine's reasonable opinion the Seller's profile
                or conduct does not comply with clause 8.1 or is otherwise
                misleading.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Engagements</h3>
              <p className="lato-regular">
                4.1 &nbsp;&nbsp;You may use the Twine Platform to engage with a
                Seller or Buyer. These Terms will not apply to any Engagement,
                and the{' '}
                <a href="/engagement-terms">
                  Twine Engagement Terms and Conditions
                </a>{' '}
                will apply. We are not party to any Engagement, which are
                between the relevant Seller and the relevant Buyer.
              </p>
              <p className="lato-regular">
                4.2 &nbsp;&nbsp;(Unless agreed with Us in writing) all
                Engagements shall be via the Twine Platform and payments can be
                made through the Twine Platform via Paypal, Stripe or any other
                payment method we may use on the Twine Platform.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Your Account</h3>
              <p className="lato-regular">
                5.1 &nbsp;&nbsp;To use the Twine Platform and the Subscription
                Services you must registered an account on the Twine Platform
                (your <strong>"Account"</strong>), and must provide us with
                certain information about you. You can create your Account via
                third party services such as Facebook or Google.
              </p>
              <p className="lato-regular">
                5.2 &nbsp;&nbsp;You must treat your user identification code,
                password and any other piece of information as part of our
                security procedures as confidential. You must not disclose it to
                any third party.
              </p>
              <p className="lato-regular">
                5.3 &nbsp;&nbsp;We have the right to disable any user
                identification code or password, whether chosen by you or
                allocated by us, at any time, if in our reasonable opinion you
                have failed to comply with any of the provisions of these terms
                of use.
              </p>
              <p className="lato-regular">
                5.4 &nbsp;&nbsp;If you know or suspect that anyone other than
                you knows your user identification code or password, you must
                promptly notify us via the Twine Chat or support@twine.net.
              </p>
              <p className="lato-regular">
                5.5 &nbsp;&nbsp;Twine may at any time, at its sole discretion,
                require you to verify or re-verify your identity, including
                through a third-party identity verification provider nominated
                by Twine, which may involve document verification and biometric
                liveness checks. You must complete any such verification within
                7 days of Twine's request. You must ensure that the name on any
                payout method registered to your Account matches your verified
                identity.
              </p>
              <p className="lato-regular">
                5.6 &nbsp;&nbsp;If you fail to complete verification within the
                period specified in clause 5.5, or if in Twine's reasonable
                opinion the verification is failed, incomplete or inconclusive,
                Twine may suspend your Account and withhold any payments or
                payouts otherwise due to you until verification is completed to
                Twine's satisfaction. Failure to complete verification
                constitutes a failure to comply with these Terms for the
                purposes of clause 15.1.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Subscriptions</h3>
              <p className="lato-regular">
                6.1 &nbsp;&nbsp;As users of the Twine Platform, you may access
                the Subscription Services by way of a subscription:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Free services – an ad-based, free-of-charge
                    services;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Pro services – a subscription fee-based service
                    which enables you to have more features as set out on the
                    Twine Platform; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Enterprise services – for use by Buyers who
                    require a number of Engagements, providing a more beneficial
                    payment structure.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                6.2 &nbsp;&nbsp;These Terms apply to the subscription by you and
                supply of Subscription Services by us to you (a{' '}
                <strong>"Subscription Contract"</strong>). They apply to the
                exclusion of any other terms that you seek to impose or
                incorporate, or which are implied by law, trade custom, practice
                or course of dealing.
              </p>
              <p className="lato-regular">
                6.3 &nbsp;&nbsp;<strong>Entire agreement.</strong> The
                Subscription Contract is the entire agreement between you and us
                in relation to its subject matter. You acknowledge that you have
                not relied on any statement, promise or representation or
                assurance or warranty that is not set out in the Subscription
                Contract.
              </p>
              <p className="lato-regular">
                6.4 &nbsp;&nbsp;<strong>Language.</strong> These Terms and the
                Subscription Contract are made only in the English language.
              </p>
              <p className="lato-regular">
                6.5 &nbsp;&nbsp;You should print off a copy of these Terms or
                save them to your computer for future reference.
              </p>
              <p className="lato-regular">
                6.6 &nbsp;&nbsp;Please follow the onscreen prompts to subscribe.
                (Unless agreed with Us directly in writing) You may only
                subscribe using the method set out on the Twine Platform. Each
                application to subscribe is an offer by you to buy the
                Subscription Services specified under that subscription package
                subject to these Terms.
              </p>
              <p className="lato-regular">
                6.7 &nbsp;&nbsp;<strong>Correcting input errors.</strong> Our
                subscription process allows you to check and amend any errors
                before submitting your order to subscribe to us. Please check
                the order carefully before confirming it. You are responsible
                for ensuring that your order is complete and accurate.
              </p>
              <p className="lato-regular">
                6.8 &nbsp;&nbsp;
                <strong>
                  Acknowledging receipt of your subscription.
                </strong>{' '}
                After you apply to subscribe, you will receive an email from us
                acknowledging that we have received it, but please note that
                this does not mean that your subscription has been successful.
                Our acceptance of your order to subscribe will take place as
                described in clause 6.9.
              </p>
              <p className="lato-regular">
                6.9 &nbsp;&nbsp;<strong>Accepting your subscription.</strong>{' '}
                Our acceptance of your subscription takes place when we send an
                email to you to accept it (
                <strong>"Subscription Confirmation"</strong>), at which point
                and on which date (<strong>"Subscription Start Date"</strong>)
                the Subscription Contract between you and us will come into
                existence.
              </p>
              <p className="lato-regular">
                6.10 &nbsp;&nbsp;
                <strong>If we cannot accept your order.</strong> If we are
                unable to accept your application to subscribe for any reason,
                we will inform you of this by email. If you have already paid
                for the Subscription, we will refund you the full amount.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Our Subscription Services</h3>
              <p className="lato-regular">
                7.1 &nbsp;&nbsp;
                <strong>
                  Descriptions, videos, animations and illustrations.
                </strong>{' '}
                Any descriptions, videos, animations or illustrations on our
                site are published for the sole purpose of giving an approximate
                idea of the services described in them. They will not form part
                of the Subscription Contract or have any contractual force.
              </p>
              <p className="lato-regular">
                7.2 &nbsp;&nbsp;<strong>Changes to specification.</strong> We
                reserve the right to amend the specification of the Subscription
                Services if required by any applicable statutory or regulatory
                requirement or if the amendment will not materially affect the
                nature or quality of the Subscription Services, and we will
                notify you in advance of any such amendment.
              </p>
              <p className="lato-regular">
                7.3 &nbsp;&nbsp;<strong>Reasonable care and skill.</strong> We
                warrant to you that the Subscription Services will be provided
                using reasonable care and skill.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Your obligations</h3>
              <p className="lato-regular">
                8.1 &nbsp;&nbsp;It is your responsibility to ensure that:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;you co-operate with us in all matters relating
                    to the Subscription Services;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;you provide us with such information and
                    materials we may reasonably require in order to register
                    your Account, create a profile and for use of the Twine
                    Platform and the Subscription Services, and ensure that such
                    information is complete and accurate in all material
                    respects, and not in any way misleading;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;you obtain and maintain all necessary licences,
                    permissions and consents which may be required for your use
                    of the Twine Platform or the Subscription Services;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;you comply with all applicable laws in your
                    location in respect of your use of the Twine Platform and
                    the Subscription Services; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;you comply with your obligations under any
                    Engagement; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;where you are a Seller, any skills, featured
                    roles, categories, experience or qualifications listed on
                    your profile are genuinely held and demonstrably supported
                    by your portfolio, work history or credentials, and your
                    profile is kept accurate and up to date at all times.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                8.2 &nbsp;&nbsp;If our ability to perform the Subscription
                Services is prevented or delayed by any failure by you to fulfil
                any obligation listed in clause 8.1 (
                <strong>"Your Default"</strong>):
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;we will be entitled to suspend performance of
                    the Subscription Services until you remedy Your Default, and
                    to rely on Your Default to relieve us from the performance
                    of the Subscription Services, in each case to the extent
                    Your Default prevents or delays performance of the
                    Subscription Services. In certain circumstances Your Default
                    may entitle us to terminate the Subscription Contract under
                    clause 15 (Termination);
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;we will not be responsible for any costs or
                    losses you sustain or incur arising directly or indirectly
                    from our failure or delay to perform the Subscription
                    Services; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;it will be your responsibility to reimburse us
                    on written demand for any costs or losses we sustain or
                    incur arising directly or indirectly from Your Default.
                  </p>
                </li>
              </ol>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Charges</h3>
              <p className="lato-regular">
                9.1 &nbsp;&nbsp;In consideration of us providing the
                Subscription Services under your Subscription you must pay the
                subscription fees as advertised on the Twine Platform at the
                Subscription Start Date (the <strong>"Subscription Fee"</strong>
                ) in accordance with this clause 9.
              </p>
              <p className="lato-regular">
                9.2 &nbsp;&nbsp;Where you enter into an Engagement, in
                consideration of us providing the Subscription Services, the
                engagement fees as advertised on the Twine Platform for each
                Subscription Service will be retained from any payments made
                under any Engagement in accordance with this clause 9.
              </p>
              <p className="lato-regular">
                9.3 &nbsp;&nbsp;We take all reasonable care to ensure that the
                Subscription Fees are correct at the time when the relevant
                information was entered into the system.
              </p>
              <p className="lato-regular">
                9.4 &nbsp;&nbsp;Our Charges are exclusive of VAT. Where VAT is
                payable in respect of some or all of the Subscription Services
                you must pay us such additional amounts in respect of VAT, at
                the applicable rate, at the same time as you pay the Charges.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">
                How to pay for Subscriptions
              </h3>
              <p className="lato-regular">
                10.1 &nbsp;&nbsp;Payment for the Subscription Fees is in
                advance.
              </p>
              <p className="lato-regular">
                10.2 &nbsp;&nbsp;You can pay any Subscription Fees by using the
                third party payment services on the Platform, and you will be
                subject to the terms and conditions of business of any third
                party payment service.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">
                Intellectual property rights
              </h3>
              <p className="lato-regular">
                11.1 &nbsp;&nbsp;All intellectual property rights in the Twine
                Platform, and in or arising out of or in connection with the
                Subscription Services (other than intellectual property rights
                in any Content) will be owned by us.
              </p>
              <p className="lato-regular">
                11.2 &nbsp;&nbsp;All intellectual property rights in any Content
                is owned by you.
              </p>
              <p className="lato-regular">
                11.3 &nbsp;&nbsp;You agree to grant us a fully paid-up,
                non-exclusive, royalty-free, non-transferable licence to use,
                copy, modify, reproduce and display any Content for the term of
                the Subscription Contract, for the purpose of providing the
                Subscription Services to you and operating, promoting and
                improving the Twine Platform.
              </p>
              <p className="lato-regular">
                11.4 &nbsp;&nbsp;You further agree to grant us a fully paid-up,
                non-exclusive, royalty-free, worldwide licence to use,
                reproduce, distribute and display any Content on any platform or
                medium, including third-party websites and social media
                platforms, for the purpose of marketing and promoting Twine's
                services. This licence survives termination of the Subscription
                Contract for so long as is reasonably necessary for the purpose
                stated above.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">
                How we may use your personal information
              </h3>
              <p className="lato-regular">
                12.1 &nbsp;&nbsp;We will use any personal information you
                provide to us to:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;provide the Subscription Services;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;process your payment for the Subscription
                    Services; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;inform you about similar services that we
                    provide, but you may stop receiving these at any time by
                    contacting us.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                12.2 &nbsp;&nbsp;Further details of how we will process personal
                information are set out in our{' '}
                <a href="/privacy">Privacy Policy</a>.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">
                Limitation of liability: YOUR ATTENTION IS PARTICULARLY DRAWN TO
                THIS CLAUSE.
              </h3>
              <p className="lato-regular">
                13.1 &nbsp;&nbsp;Nothing in the Subscription Contract limits any
                liability which cannot legally be limited, including liability
                for:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;death or personal injury caused by negligence;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;fraud or fraudulent misrepresentation; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;breach of the terms implied by section 2 of the
                    Supply of Goods and Services Act 1982 (title and quiet
                    possession).
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                13.2 &nbsp;&nbsp;Subject to clause 13.1, we will not be liable
                to you, whether in contract, tort (including negligence), for
                breach of statutory duty, or otherwise, arising under or in
                connection with the Subscription Contract for:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular"> &nbsp;&nbsp;loss of profits;</p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;loss of sales or business;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;loss of agreements or contracts;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;loss of anticipated savings;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;loss of use or corruption of software, data or
                    information;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;loss of or damage to goodwill; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;any indirect or consequential loss.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                13.3 &nbsp;&nbsp;Subject to clause 13.1, our total liability to
                you arising under or in connection with the Subscription
                Contract, whether in contract, tort (including negligence),
                breach of statutory duty, or otherwise, will be limited to 100%
                of any Subscription Fees paid.
              </p>
              <p className="lato-regular">
                13.4 &nbsp;&nbsp;We have given commitments as to compliance of
                the Subscription Services with the relevant specification in
                clause 7. In view of these commitments, the terms implied by
                sections 3 and 5 of the Supply of Goods and Services Act 1982
                are, to the fullest extent permitted by law, excluded from the
                Subscription Contract.
              </p>
              <p className="lato-regular">
                13.5 &nbsp;&nbsp;Unless you notify us that you intend to make a
                claim in respect of an event within the notice period, we shall
                have no liability for that event. The notice period for an event
                shall start on the day on which you became, or ought reasonably
                to have become, aware of the event having occurred and shall
                expire six months from that date. The notice must be in writing
                and must identify the event and the grounds for the claim in
                reasonable detail.
              </p>
              <p className="lato-regular">
                13.6 &nbsp;&nbsp;Nothing in these Terms limits or affects the
                exclusions and limitations set out in our Website{' '}
                <a href="/terms">Terms and Conditions</a>.
              </p>
              <p className="lato-regular">
                13.7 &nbsp;&nbsp;This clause 13 will survive termination of the
                Subscription Contract.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Confidentiality</h3>
              <p className="lato-regular">
                14.1 &nbsp;&nbsp;We each undertake that we will not at any time
                disclose to any person any confidential information concerning
                one another's business, affairs, customers, clients or
                suppliers, except as permitted by clause 14.2.
              </p>
              <p className="lato-regular">
                14.2 &nbsp;&nbsp;We each may disclose the other's confidential
                information:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;to such of our respective employees, officers,
                    representatives, subcontractors or advisers who need to know
                    such information for the purposes of exercising our
                    respective rights or carrying out our respective obligations
                    under the Subscription Contract. We will each ensure that
                    such employees, officers, representatives, subcontractors or
                    advisers comply with this clause 14; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;as may be required by law, a court of competent
                    jurisdiction or any governmental or regulatory authority.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                14.3 &nbsp;&nbsp;Each of us may only use the other's
                confidential information for the purpose of fulfilling our
                respective obligations under the Subscription Contract.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Termination</h3>
              <p className="lato-regular">
                15.1 &nbsp;&nbsp;Failure to comply with these Terms constitutes
                a material breach of the Subscription Contract, and may result
                in our taking of all or any of the following actions:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Immediate, temporary or permanent withdrawal of
                    your right to use the Twine Platform;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Immediate, temporary or permanent suspension of
                    your Account.
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Issue of a warning to you.
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Legal proceedings against you for reimbursement
                    of all costs on an indemnity basis (including, but not
                    limited to, reasonable administrative and legal costs)
                    resulting from the breach.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                15.2 &nbsp;&nbsp;If we end your rights to use the Twine Platform
                you must stop all activities authorised by these Terms,
                including your use of the Twine Platform.
              </p>
              <p className="lato-regular">
                15.3 &nbsp;&nbsp;Without limiting any of our other rights, we
                may suspend the performance of the Subscription Services, or
                terminate the Subscription Contract with immediate effect by
                giving written notice to you if:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;you commit a material breach of any term of the
                    Subscription Contract and (if such a breach is remediable)
                    fail to remedy that breach within five days of you being
                    notified in writing to do so;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;you fail to pay any amount due under the
                    Subscription Contract on the due date for payment;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;you take any step or action in connection with
                    you entering administration, provisional liquidation or any
                    composition or arrangement with your creditors (other than
                    in relation to a solvent restructuring), being wound up
                    (whether voluntarily or by order of the court, unless for
                    the purpose of a solvent restructuring), having a receiver
                    appointed to any of your assets or ceasing to carry on
                    business or, if the step or action is taken in another
                    jurisdiction, in connection with any analogous procedure in
                    the relevant jurisdiction;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;you suspend, threaten to suspend, cease or
                    threaten to cease to carry on all or a substantial part of
                    your business; or
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;your financial position deteriorates to such an
                    extent that in our opinion your capability to adequately
                    fulfil your obligations under the Subscription Contract has
                    been placed in jeopardy.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                15.4 &nbsp;&nbsp;Termination of the Subscription Contract will
                not affect your or our rights and remedies that have accrued as
                at termination.
              </p>
              <p className="lato-regular">
                15.5 &nbsp;&nbsp;Any provision of the Subscription Contract that
                expressly or by implication is intended to come into or continue
                in force on or after termination will remain in full force and
                effect.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Events outside our control</h3>
              <p className="lato-regular">
                16.1 &nbsp;&nbsp;We will not be liable or responsible for any
                failure to perform, or delay in performance of, any of our
                obligations under the Subscription Contract that is caused by
                any act or event beyond our reasonable control (
                <strong>"Event Outside Our Control"</strong>).
              </p>
              <p className="lato-regular">
                16.2 &nbsp;&nbsp;If an Event Outside Our Control takes place
                that affects the performance of our obligations under the
                Subscription Contract:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;we will contact you as soon as reasonably
                    possible to notify you; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;our obligations under the Subscription Contract
                    will be suspended and the time for performance of our
                    obligations will be extended for the duration of the Event
                    Outside Our Control. We will arrange a new date for
                    performance of the Subscription Services with you after the
                    Event Outside Our Control is over.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                16.3 &nbsp;&nbsp;You may cancel the Subscription Contract
                affected by an Event Outside Our Control. To cancel please
                contact us. If you opt to cancel we will refund the price you
                have paid, less the charges reasonably and actually incurred us
                by in performing the Subscription Services up to the date of the
                occurrence of the Event Outside Our Control.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Communications between us</h3>
              <p className="lato-regular">
                17.1 &nbsp;&nbsp;When we refer to "in writing" in these Terms,
                this includes email.
              </p>
              <p className="lato-regular">
                17.2 &nbsp;&nbsp;Any notice or other communication given by one
                of us to the other under or in connection with the Subscription
                Contract must be in writing and be delivered personally, sent by
                pre-paid first class post or other next working day delivery
                service, or email.
              </p>
              <p className="lato-regular">
                17.3 &nbsp;&nbsp;A notice or other communication is deemed to
                have been received:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;if delivered personally, on signature of a
                    delivery receipt or at the time the notice is left at the
                    proper address;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;if sent by pre-paid first class post or other
                    next working day delivery service, at 9.00 am on the second
                    working day after posting; or
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;if sent by email, at 9.00 am GMT the next
                    working day after transmission.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                17.4 &nbsp;&nbsp;In proving the service of any notice, it will
                be sufficient to prove, in the case of a letter, that such
                letter was properly addressed, stamped and placed in the post
                and, in the case of an email, that such email was sent to the
                specified email address of the addressee.
              </p>
              <p className="lato-regular">
                17.5 &nbsp;&nbsp;The provisions of this clause will not apply to
                the service of any proceedings or other documents in any legal
                action.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">General</h3>
              <p className="lato-regular">
                18.1 &nbsp;&nbsp;<strong>Assignment and transfer.</strong>
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;We may assign or transfer our rights and
                    obligations under the Subscription Contract to another
                    entity but will always notify you f this happens.
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;You may only assign or transfer your rights or
                    your obligations under the Subscription Contract to another
                    person if we agree in writing.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                18.2 &nbsp;&nbsp;<strong>Variation.</strong> Any variation of
                the Subscription Contract only has effect if it is in writing
                and signed by you and us (or our respective authorised
                representatives).
              </p>
              <p className="lato-regular">
                18.3 &nbsp;&nbsp;<strong>Waiver.</strong> If we do not insist
                that you perform any of your obligations under the Subscription
                Contract, or if we do not enforce our rights against you, or if
                we delay in doing so, that will not mean that we have waived our
                rights against you or that you do not have to comply with those
                obligations. If we do waive any rights, we will only do so in
                writing, and that will not mean that we will automatically waive
                any right related to any later default by you.
              </p>
              <p className="lato-regular">
                18.4 &nbsp;&nbsp;<strong>Severance.</strong> Each paragraph of
                these Terms operates separately. If any court or relevant
                authority decides that any of them is unlawful or unenforceable,
                the remaining paragraphs will remain in full force and effect.
              </p>
              <p className="lato-regular">
                18.5 &nbsp;&nbsp;<strong>Third party rights.</strong> These
                Terms and any Subscription Contract is between you and us. No
                other person has any rights to enforce any of its terms.
              </p>
              <p className="lato-regular">
                18.6 &nbsp;&nbsp;
                <strong>Governing law and jurisdiction.</strong> These Terms and
                any Subscription Contract is governed by English law and we each
                irrevocably agree to submit all disputes arising out of or in
                connection with the Subscription Contract to the exclusive
                jurisdiction of the English courts.
              </p>
              <p className="lato-regular">
                18.7 &nbsp;&nbsp;You are responsible for any Engagement you
                enter into.
              </p>
              <p className="lato-regular">
                18.8 &nbsp;&nbsp;
                <strong>
                  <u>
                    We make no claims or representations that the Twine Platform
                    or Subscription Services are lawful or are permitted in any
                    jurisdiction outside of England and Wales. You use the Twine
                    Platform or Subscription Services at your own risk and you
                    are responsible for compliance with all local and national
                    laws and regulations in the jurisdiction where you access
                    the Twine Platform.
                  </u>
                </strong>
              </p>
            </li>
          </ol>

          <hr />

          <p className="lato-regular">
            For further terms of using Twine, please read our{' '}
            <a href="/terms">Terms and Conditions</a>.
          </p>
        </div>
      </div>
    );
  }
}
